export default __webpack_public_path__ + "static/media/Time_00.33b33e79.png";